var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureLocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.2 20",
    style: {
      enableBackground: "new 0 0 15.2 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,6.7h-1V4.8c0-2.7-2.1-4.8-4.8-4.8C5,0,2.9,2.1,2.9,4.8v1.9h-1C0.9,6.7,0,7.5,0,8.6v9.5 c0,1,0.9,1.9,1.9,1.9h11.4c1,0,1.9-0.9,1.9-1.9V8.6C15.2,7.5,14.4,6.7,13.3,6.7z M7.6,1.8c1.6,0,3,1.3,3,3v1.9H4.8V4.8l0,0 C4.8,3.1,6,1.8,7.6,1.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureLocket);
export default __webpack_public_path__ + "static/media/secureLocket.77b0e1be.svg";
export { ForwardRef as ReactComponent };